import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Techstock() {
  return (
    <section className="tech_stock p-100 text_white bg_stock text_stock">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>
              <span>TECH</span> STACK
            </h2>
          </Col>
        </Row>
        <Row className="pt-top">
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="text-center">
            <div className="tech_item">
              <h5>BACKEND: APIS & ADMIN PANEL</h5>
              <p>Node JS</p>
              <StaticImage
                src="../../../images/case-studies/stock/icon_1.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={207}
                height={128}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="text-center">
            <div className="tech_item">
              <h5>WEB APP</h5>
              <p>React</p>
              <StaticImage
                src="../../../images/case-studies/stock/icon_2.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={142}
                height={128}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="text-center">
            <div className="tech_item">
              <h5>SERVER & HOSTING</h5>
              <p>AWS – S3</p>
              <StaticImage
                src="../../../images/case-studies/stock/icon_3.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={106}
                height={128}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={3} xl={3} xxl={3} className="text-center">
            <div className="tech_item">
              <h5>TOOLS AND TESTING</h5>
              <p>Manual Testing – Test Cases – JIRA</p>
              <StaticImage
                src="../../../images/case-studies/stock/icon_4.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={128}
                height={128}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Techstock;
